/*
  * File selector component specific for Adalia M&E.
  * 
  * Project can be passed as a prop, but if not,
  * this component expects the document to contain an element with an id report-container and that element have a data-attribute called project-id.
  * 
  */
 import React from 'react';

 import {
     Mode,
 } from '../common.jsx'
 import Helpers from './helpers.jsx';
 
 import GridLayout from './grid_layout.jsx';
 import DropdownSelectionWithAsyncOptions from './dropdown_selection_with_async_options.jsx';
 import Label from './label.jsx';
 import RepeatableRegion from './repeatable_region.jsx';

import {
    project_get_project_file_list_path,
    download_project_file_path
} from '~/routes';
 
 const SETTINGS_DUMMY_DATA = [
  {value: 0, label: '1.1 Example file'},
  {value: 1, label: '1.2 Example file'},
  {value: 2, label: '1.3 Example file'}
]

const fetchProjectFiles = (project_id, cb) => {
    $.getJSON(
        project_get_project_file_list_path({project_id: project_id}),
        (res) => {
            let file_options = [{value: null, label: I18n.t('field_default_file_selector_please_select', {scope: 'fe'})}];
            res.project_files.forEach((r) => {
                file_options.push({value: r.id, label: r.name})
            })
            cb(file_options);
        }
    )
}
 export default class AdaliaMEFileSelector extends GridLayout {
         static get CATEGORY() {
             return 'question';
         }
 
         static get TYPE() {
             return 'adalia_me_file_selector';
         }
 
         static icon(){
             return <i className="fa fa-file"></i>;
         }
 
         static defaultContent(language) {
             let fieldName = 'field_' + Helpers.randomString();
 
             let fileTranslations = AdaliaMEFileSelector.defaultContentTranslations(language);
             fileTranslations[language] = Object.assign(fileTranslations[language], {
                 label: '',
                 description: '',
                 placeholder: ''
             });

             let labelTranslations = Label.defaultContentTranslations(language);
             labelTranslations[language] = Object.assign(labelTranslations[language], {
                 text: I18n.t('field_default_file_selector_label', {scope: 'fe', locale: language}),
                 description: I18n.t('field_default_file_selector_description', {scope: 'fe', locale: language})
             });

 
             return Object.assign(super.defaultContent(language), {
                 rows: [
                     [
                      {
                        span: 1,
                        component: Object.assign(Label.defaultContent(language), {
                            name: fieldName + '_file_selector',
                            deletable: false,
                            sortable: false,
                            translations: labelTranslations
                        })
                      }
                     ],
                     [
                        {
                          span: 1,
                          component: Object.assign(AdaliaMEFileSelectorRepeatableRegion.defaultContent(language), {
                              name: fieldName + '_file_selector_repetable',
                              deletable: false,
                              sortable: false,
                              translations: fileTranslations,
                              component: Object.assign(AdaliaMEFileDropdown.defaultContent(language), {
                                    name: fieldName + '_file',
                                    deletable: false,
                                    sortable: false,
                                    translations: fileTranslations
                                })
                            }),                         
                        }
                    ]
                 ]
             });
         }
 
         constructor(props) {
             super(props);
         }
 
         renderSettings() {
         }
 }
 
 
 export class AdaliaMEFileSelectorGrid extends GridLayout {
         static defaultContent(language) {
             return Object.assign(super.defaultContent(language), {
                 deletable: false,
                 sortable: false,
                 reportKey: ''
             });
         }
 
         static get TYPE() {
             return 'adalia_me_file_selector_grid';
         }
 
         renderSettings() {
         }
 }

 export class AdaliaMEFileSelectorRepeatableRegion extends RepeatableRegion {
    static defaultContent(language) {
        return Object.assign(super.defaultContent(language), {
            deletable: false,
            sortable: false,
            reportKey: ''
        });
    }

    static get TYPE() {
        return 'adalia_me_file_selector_repetable_region';
    }

    renderSettings() {
    }

 }

 export class AdaliaMEFileDropdown extends DropdownSelectionWithAsyncOptions {

  static defaultContent(language) {
    return Object.assign(super.defaultContent(language), {
        deletable: false,
        sortable: false,
        reportKey: ''
    });
  }

  static get TYPE() {
      return 'adalia_me_file_dropdown';
  }

  renderSettings() {
  }

  renderView() {
    const selectedFile = this.getSelectedOptions();
    let hasFileSelected = selectedFile && selectedFile.value
    let project_id = this.props.project?.id || jQuery('#report-container').data('project-id');
    if(this.props.mode == Mode.VIEW){
        return hasFileSelected ? <div className = 'dropzone printable-dropzone'>
        <div className='dz-preview dz-file-preview old'>
          <div className="dz-details" style={{padding: 10}}>
              <span className="dz-filename">
                <a href={download_project_file_path({project_id: project_id, file_id: selectedFile.value})}
                    data-turbo="false"
                    data-av="true" 
                    data-av-show-download-link="true"
                    target="_blank">
                  {selectedFile.label}
                </a>
              </span>
          </div>
        </div>
      </div> : <div>{I18n.t('no_file_linked', {scope: 'fe', locale: I18n.locale})}</div>
    }else{
        return <div className="row">
          <div className="col-xs-12">
            {super.renderView()}
          </div>
        </div>
    }
  }

  componentDidMount() {
    super.componentDidMount();

    let project_id = this.props.project?.id || jQuery('#report-container').data('project-id');
    if ([Mode.EDIT, Mode.SETTINGS].includes(this.props.mode)) {
       this.setState({options: SETTINGS_DUMMY_DATA, loading: false})
     } else {
        if(project_id){
            fetchProjectFiles(project_id, (res) => {
            if (res){
              this.setState({
                options: res,
                loading: false,
              }, this.initSelect2)
            }
          })
        }
        else{
          this.setState({options: SETTINGS_DUMMY_DATA, loading: false})
        }
    }
  }

 }